import * as Actions from './actions'
import {initialState} from '../store/initialState'

export const CategoriesReducer = (state = initialState.categories, action) =>{
    switch(action.type){
        case Actions.DELETE_CATEGORIES:
            return{
                ...state,
                list:[...action.payload]//新しい配列として更新する。コンポーネント側で変更を検知するため。
            };
        case Actions.FETCH_CATEGORIES:
            return{
                ...state,
                list:[...action.payload]//新しい配列として更新する。コンポーネント側で変更を検知するため。
            };
        case Actions.INIT_CATEGORIES:
            return {
                ...initialState.products
            };
        default:
            return state
    }
}